import { useContext } from 'react'
import { WebCrafterContext } from '../contexts/WebCrafterContext.jsx'

/**
 * Main hook to access WebCrafter context
 */
export function useWebCrafter()
{
    const context = useContext(WebCrafterContext)
    if (!context) throw new Error('useWebCrafter must be used within a WebCrafterProvider')
    return context
}

export const useScene = useWebCrafter

export function useSceneManager()
{
    return useWebCrafter().sceneManager
}

export function useCameraManager()
{
    return useWebCrafter().cameraManager
}

export function useInteractionManager()
{
    return useWebCrafter().interactionManager
}

export function useSiteData()
{
    return useWebCrafter().siteData
}

export function useApi()
{
    return useWebCrafter().api
}
